import { render } from "./AdminProfileDetail.vue?vue&type=template&id=333a903a"
import script from "./AdminProfileDetail.vue?vue&type=script&lang=js"
export * from "./AdminProfileDetail.vue?vue&type=script&lang=js"

import "./AdminProfileDetail.vue?vue&type=style&index=0&id=333a903a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__